import { render, staticRenderFns } from "./TimeExpiringDialog.vue?vue&type=template&id=297eeb59"
import script from "./TimeExpiringDialog.vue?vue&type=script&lang=ts"
export * from "./TimeExpiringDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports